import { InjectionToken } from '@angular/core';
import { IAccountStorageRepository } from '../repositories/account-storage.repository';

export const ACCOUNT_STORAGE_REPOSITORY =
  new InjectionToken<IAccountStorageRepository>('ACCOUNT_STORAGE_REPOSITORY');
